import React from 'react';

import Home from "../pages";
import Error from "../pages/error";

const Expired= React.lazy(() => import("../pages/expired"));
const Survey = React.lazy(() => import("../pages/Survey"));
const RegisterForm = React.lazy(() => import("../pages/Survey/register"));
const ShortLink = React.lazy(() => import("../pages/ShortLinkTracking"));
const LandingLink = React.lazy(() => import("../pages/LandingLink"));
const ConnectAdminLine = React.lazy(() => import("../pages/Connect/AdminLine"));


export const ROUTE_PATHS = {
  ROOT: "/",

  CONNECT_ADMIN_LINE: "/connect/admin/:accountId/line",
  CONNECT_ADMIN_LINE_CLEAR: "/connect/admin/:accountId/line/unsync",
  LINK_SHORT_API: "/x/:shortId",
  LINK_SHORT_API_UTM: "/x/:shortId/:utmNo",
  LINK_SHORT_API_R: "/r/:shortId",
  LINK_SHORT_API_UTM_R: "/r/:shortId/:utmNo",
  LINK_SHORT_API_E: "/e/:shortId",
  LINK_SHORT_API_UTM_E: "/e/:shortId/:utmNo",
  LINK_LANDING: "/lp/:shortId",
  LINK_LANDING_UTM: "/lp/:shortId/:utmNo",
  LINK_SHORT_API_SURVEY: "/s/:shortId",
  LINK_SHORT_API_UTM_SURVEY: "/s/:shortId/:utmNo",
  
  REGISTER_FORM: "/crm/register/:surveyId",
  REGISTER_PREVIEW_FORM: "/crm/register/:surveyId/test",
  REGISTER_FORM_T: "/crm/regiser/:surveyId",
  REGISTER_PREVIEW_T_FORM: "/crm/regiser/:surveyId/test",

  SURVEY_INIT: "/survey/",
  SURVEY: "/survey/:surveyId",
  SURVEY_PREVIEW: "/survey/:surveyId/preview",
  SURVEY_EXPIRED: "/survey/expired",
  
  NOT_FOUND: "/404",
  ALL: "*",
};

export const routes = [
  {
    element: <Home />,
    path: ROUTE_PATHS.ROOT,
  },
  {
    element: <ConnectAdminLine />,
    path: ROUTE_PATHS.CONNECT_ADMIN_LINE,
  },
  {
    element: <ConnectAdminLine unsync={true} />,
    path: ROUTE_PATHS.CONNECT_ADMIN_LINE_CLEAR,
  },
  {
    element: <ShortLink />,
    path: ROUTE_PATHS.LINK_SHORT_API,
  },
  {
    element: <ShortLink />,
    path: ROUTE_PATHS.LINK_SHORT_API_UTM,
  },
  {
    element: <LandingLink />,
    path: ROUTE_PATHS.LINK_LANDING,
  },
  {
    element: <LandingLink />,
    path: ROUTE_PATHS.LINK_LANDING_UTM,
  },
  {
    element: <ShortLink />,
    path: ROUTE_PATHS.LINK_SHORT_API_R,
  },
  {
    element: <ShortLink />,
    path: ROUTE_PATHS.LINK_SHORT_API_UTM_R,
  },
  {
    element: <ShortLink />,
    path: ROUTE_PATHS.LINK_SHORT_API_E,
  },
  {
    element: <ShortLink />,
    path: ROUTE_PATHS.LINK_SHORT_API_UTM_E,
  },
  {
    element: <ShortLink />,
    path: ROUTE_PATHS.LINK_SHORT_API_SURVEY,
  },
  {
    element: <ShortLink />,
    path: ROUTE_PATHS.LINK_SHORT_API_UTM_SURVEY,
  },
  {
    element: <RegisterForm />,
    path: ROUTE_PATHS.REGISTER_FORM,
  },
  {
    element: <RegisterForm isPreviewMode={true} />,
    path: ROUTE_PATHS.REGISTER_PREVIEW_FORM,
  },
  {
    element: <RegisterForm />,
    path: ROUTE_PATHS.REGISTER_FORM_T,
  },
  {
    element: <RegisterForm isPreviewMode={true} />,
    path: ROUTE_PATHS.REGISTER_PREVIEW_T_FORM,
  },

  {
    element: <Home />,
    path: ROUTE_PATHS.SURVEY_INIT,
  },
  {
    element: <Survey />,
    path: ROUTE_PATHS.SURVEY,
  },
  {
    element: <Survey isPreviewMode={true} />,
    path: ROUTE_PATHS.SURVEY_PREVIEW,
  },
  {
    element: <Error />,
    path: ROUTE_PATHS.NOT_FOUND,
  },
  {
    element: <Expired />,
    path: ROUTE_PATHS.SURVEY_EXPIRED,
  },
];
